import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import FilterTabs from './partials/FilterTabs'
import Api from '../../../_helpers/Api'
import { trans } from '../../../_providers/Translation'

//partials
import TaskInfo from './partials/TaskInfo'
import Parts from './partials/parts/Index'
import Comments from './partials/Comments'
import Todo from './partials/Todo'
import Invoices from './partials/Invoices'
import History from './partials/History'
import loader from '../../../assets/img/loader.svg'
import { TYPE } from '../../../_constants/Reservation'
import Help from '../../partials/Help'

// styles
import "@/assets/scss/pages/reservations.scss"
import { enqueueSnackbar } from 'notistack'

function CreateEdit() {
    const params = useParams()
    const history = useHistory()
    const location = useLocation()

    const id = params.id

    const addMode = id ? false : true
    const editMode = id ? true : false

    const searchParams = new URLSearchParams(location.search)

    const tabs = ['info', 'parts', 'todo', 'comments', 'invoices', 'history']

    const tab = searchParams.get('tab')
    const urlIndicator = searchParams.get('indicator')

    const [reservation, setReservation] = useState({
        tab: tabs.indexOf(tab) > -1 ? tab : tabs[0],
        data: {
            can_modify: true,
            can_modify_appliance: true,
            can_modify_initial_status: true,
            can_reassign: true,
            contractor: {},
            customer: {},
            appliancecategory: {},
            appliancebrand: {},
            appliancemodel: {},
            diagnostic_price: 0,
            transport_price: 0,
            labour_price: 0,
            parts_price: 0,
            calculate_labour_price: true
        },
        tabsCount: {
            commentsCount: 0,
            partsCount: 0,
            todosCount: 0,
            manualsCount: 0,
            invoicesCount: 0
        },
        update: false,
        loading: editMode ? true : false,
    })

    const [settings, setSettings] = useState({
        data: null,
        loading: true,
    })

    const [loadingOnDelete, setLoadingOnDelete] = useState(false)

    useEffect(() => {

        let employeeId = searchParams.get('employee_id')
        let date = searchParams.get('date')
        let periodId = searchParams.get('visit_period_id')
        let address = searchParams.get('address')
        let lat = searchParams.get('lat')
        let lon = searchParams.get('lon')

        setReservation(prev => ({
            ...prev,
            tab: tabs.indexOf(tab) > -1 ? tab : tabs[0],
        }))

        if (employeeId) {
            setReservation(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    performer: {
                        id: employeeId,
                        type: 'App\\Models\\Employee'
                    }
                }
            }))
        }

        // YYYY-mm-dd
        if (date) {
            setReservation(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    visit_date_ymd: date
                }
            }))
        }

        if (periodId) {
            setReservation(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    visit_period_id: periodId
                }
            }))
        }

        if (address) {
            setReservation(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    address: address
                }
            }))
        }

        if (lat && lon) {
            setReservation(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    lat: Number(lat),
                    lon: Number(lon)
                }
            }))
        }

    }, [location.search])

    useEffect(() => {
        if (editMode) {

            setReservation(prev => ({
                ...prev,
                loading: true
            }))

            // Build API URL with shared reservation parameters
            let apiUrl = `reservations/find?id=${id}`
            const isShared = searchParams.get('is_shared')
            const sharedByTenantId = searchParams.get('shared_by_tenant_id')
            const allowedActions = searchParams.get('allowed_actions')

            if (isShared === 'true') {
                apiUrl += '&is_shared=true'
            }

            if (sharedByTenantId) {
                apiUrl += `&shared_by_tenant_id=${encodeURIComponent(sharedByTenantId)}`
            }

            if (allowedActions) {
                apiUrl += `&allowed_actions=${encodeURIComponent(allowedActions)}`
            }

            Api.get(apiUrl)
                .then(res => {
                    // setReservation(reservation => ({
                    //     ...reservation,
                    //     data: res.data,
                    setReservation(reservation => ({
                        ...reservation,
                        data: {
                            // keep backend payload, but ensure appliances array exists for the UI
                            ...res.data,
                            appliances: Array.isArray(res.data.appliances) ? res.data.appliances.map(ap => ({
                                ...ap,
                                appliancecategory: ap.appliancecategory || (ap.appliance_category_id ? { id: ap.appliance_category_id } : {}),
                                appliancebrand: ap.appliancebrand || (ap.appliance_brand_id ? { id: ap.appliance_brand_id, name: ap.appliance_brand_name || '' } : {}),
                                appliancemodel: ap.appliancemodel || (ap.appliance_model_id ? { id: ap.appliance_model_id, name: ap.appliance_model_name || '' } : {}),
                            })) : (
                                res.data.appliancecategory || res.data.appliancebrand || res.data.appliancemodel
                                    ? [{
                                        category: res.data.appliancecategory?.name || res.data.appliancecategory || '',
                                        brand: res.data.appliancebrand?.name || res.data.appliancebrand || '',
                                        model: res.data.appliancemodel?.name || res.data.appliancemodel || '',
                                        serial: res.data.appliance_serial || '',
                                        qty: 1
                                    }]
                                    : []
                            ),
                            // Handle shared reservation data from backend
                            is_shared: res.data.is_shared ?? false,
                            shared_by_tenant_id: res.data.shared_by_tenant_id ?? null,
                            allowed_actions: res.data.allowed_actions ?? ['all']
                        },
                        tabsCount: {
                            commentsCount: res.data.comments_count,
                            partsCount: res.data.parts_count,
                            todosCount: res.data.todos_count,
                            manualsCount: res.data.manuals_count,
                            invoicesCount: res.data.invoices_count
                        }
                    }))
                })
                .catch(err => {
                    if (err.response?.status === 404) {
                        history.push('/reservations')
                    }
                })
                .finally(() => {
                    setReservation(prev => ({
                        ...prev,
                        loading: false
                    }))
                })
        }
    }, [id, urlIndicator, reservation.update])

    useEffect(() => {
        loadSettings()
    }, [])

    const loadSettings = (retry = 0) => {
        // Get shared reservation parameters from URL
        const isShared = searchParams.get('is_shared') === 'true'
        const sharedByTenantId = searchParams.get('shared_by_tenant_id')

        // Build API endpoint with parameters
        let endpoint = 'partners/settings/pricing'
        const params = new URLSearchParams()

        if (isShared && sharedByTenantId) {
            params.append('is_shared', 'true')
            params.append('shared_by_tenant_id', sharedByTenantId)
        }

        const queryString = params.toString()
        if (queryString) {
            endpoint += '?' + queryString
        }

        Api.get(endpoint)
            .then(res => {
                setSettings(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false
                }))
            })
            .catch(err => {
                if (retry < 3) {
                    loadSettings(retry + 1)
                }
            })
    }

    const handleTab = newValue => {
        // Preserve existing URL parameters and only update the tab
        const currentParams = new URLSearchParams(location.search)
        currentParams.set('tab', newValue)

        history.push(`?${currentParams.toString()}`)

        setReservation(reservation => ({
            ...reservation,
            tab: newValue
        }))
    }


    const setOriginal = data => {
        setReservation(prev => ({
            ...prev,
            data: data
        }))
    }

    const refreshData = () => {
        setReservation(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const [sharedActionLoading, setSharedActionLoading] = useState(false)

    const handleAcceptShared = async () => {
        const sharedId = reservation.data.shared_reservation_main_db_id
            || reservation.data.shared_reserv_id
            || reservation.data.sharedReservationId
        if (!sharedId) return
        setSharedActionLoading(true)
        try {
            await Api.post(`shared-reservations/${sharedId}/accept`)
            refreshData()
        } catch (e) {
            console.error('[SharedReserv] accept error:', e)
        } finally {
            setSharedActionLoading(false)
        }
    }

    const handleDeclineShared = async () => {
        const sharedId = reservation.data.shared_reservation_main_db_id
            || reservation.data.shared_reserv_id
            || reservation.data.sharedReservationId

        if (!sharedId) return
        setSharedActionLoading(true)
        try {
            await Api.post(`shared-reservations/${sharedId}/decline`)
            history.push('/reservations')
        } catch (e) {
            console.error('[SharedReserv] decline error:', e)
        } finally {
            setSharedActionLoading(false)
        }
    }

    const calculatePrice = () => {
        // Build API URL with shared reservation parameters
        let apiUrl = `reservations/calculate-price?id=${id}`
        const isShared = searchParams.get('is_shared')
        const sharedByTenantId = searchParams.get('shared_by_tenant_id')
        const currentTenantId = searchParams.get('current_tenant_id')

        if (isShared === 'true') {
            apiUrl += '&is_shared=true'
        }

        if (sharedByTenantId) {
            apiUrl += `&shared_by_tenant_id=${encodeURIComponent(sharedByTenantId)}`
        }

        if (currentTenantId) {
            apiUrl += `&current_tenant_id=${encodeURIComponent(currentTenantId)}`
        }

        Api.get(apiUrl)
            .then(res => {
                Object.entries(res.data).map(p => {
                    setReservation(prev => ({
                        ...prev,
                        data: {
                            ...prev.data,
                            [p[0]]: p[1]
                        }
                    }))
                })
            })
    }

    const isAddress = () => {
        if (Number(reservation.data.res_type_id) === TYPE.ADDRESS) {
            return true
        }

        return params.type === 'address'
    }

    const isOnSiteRepair = () => {
        if (Number(reservation.data.res_type_id) === TYPE.ON_SITE_REPAIR) {
            return true
        }

        return params.type === 'service'
    }

    const getResTypeId = () => {
        if (isAddress()) {
            return TYPE.ADDRESS
        }

        if (isOnSiteRepair()) {
            return TYPE.ON_SITE_REPAIR
        }
    }

    const getResType = () => {
        if (isAddress()) {
            return 'address'
        }

        if (isOnSiteRepair()) {
            return 'service'
        }
    }

    const ReservationStatus = ({ finalStatusId, initialStatusId }) => {
        if (addMode) {
            return <></>
        }

        const status = (!initialStatusId || initialStatusId === '')
            ? 'no'
            : (finalStatusId !== null && finalStatusId !== '')
                ? 'completed'
                : 'active'

        const statusConfig = {
            completed: {
                label: trans('labels.reservation-status.completed'),
                color: '#3A61FF',
            },
            active: {
                label: trans('labels.reservation-status.active'),
                color: '#89B9B9',
            },
            no: {
                label: '',
                color: '#D4D9EE',
            }
        }

        return (
            <div className='status-in-heading'>
                <span style={{
                    backgroundColor: statusConfig[status].color
                }}></span>
                {statusConfig[status].label}
            </div>
        )
    }

    return (
        <div className="wrapper">
            <div className="top-part">
                <div className="left">
                    <h1
                        className="page-heading"
                        style={{
                            display: "flex",
                            alignItems: 'center',
                            gap: '20px'
                        }}
                    >
                        {addMode
                            ?
                            isAddress()
                                ?
                                trans('headings.addAddressReservation')
                                :
                                isOnSiteRepair()
                                    ?
                                    trans('headings.addServiceReservation')
                                    :
                                    trans('headings.addReservation')
                            :
                            isAddress()
                                ?
                                `${trans('headings.editAddressReservation')} #${reservation.data.reference_code}`
                                :
                                isOnSiteRepair()
                                    ?
                                    `${trans('headings.editServiceReservation')} #${reservation.data.reference_code}`
                                    :
                                    `${trans('headings.editReservation')} #${reservation.data.reference_code}`}
                        <ReservationStatus finalStatusId={reservation.data.final_status_id} initialStatusId={reservation.data.initial_status_id} />
                    </h1>

                    <p className="page-subheading">
                        {trans('subheadings.createEditReservations')}
                    </p>
                </div>
            </div>

            {editMode && reservation.data.is_shared_reserv_awaiting_response_by_me && (
                <div className="alert warning" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{ flex: 1 }}>{trans('messages.sharedReservationNotRespondedYet')}</span>
                    <button
                        className="button button-success button-small"
                        onClick={handleAcceptShared}
                        disabled={sharedActionLoading}
                    >
                        {sharedActionLoading ? '...' : 'Приеми'}
                    </button>
                    <button
                        className="button button-danger button-small"
                        onClick={handleDeclineShared}
                        disabled={sharedActionLoading}
                    >
                        {sharedActionLoading ? '...' : 'Отхвърли'}
                    </button>
                </div>
            )}


            {editMode && reservation.data.is_copy && reservation.data.share_status === "declined" ? (
                <div className="alert warning" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{ flex: 1 }}>{trans('messages.declinedReservation')}</span>
                </div>
            ) : <></>}

            <div style={reservation.data.is_shared_reserv_awaiting_response_by_me || !reservation.data.can_modify ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
                <FilterTabs
                    editMode={editMode}
                    tab={reservation.tab}
                    loading={reservation.loading}
                    reservationId={id}
                    referenceCode={reservation.data.reference_code}
                    categoryId={reservation.data.appliance_category_id}
                    brandId={reservation.data.appliance_brand_id}
                    modelId={reservation.data.appliance_model_id}
                    model={reservation.data.appliancemodel ? reservation.data.appliancemodel.name : ''}
                    tabsCount={reservation.tabsCount}
                    handleTab={handleTab}
                />

                <div style={{ display: reservation.tab === 'info' ? 'block' : 'none' }}>
                    <TaskInfo
                        addMode={addMode}
                        loading={reservation.loading || settings.loading}
                        data={reservation.data}
                        settings={settings.data?.settings}
                        tabsCount={reservation.tabsCount}
                        setOriginal={setOriginal}
                        isAddress={isAddress}
                        isOnSiteRepair={isOnSiteRepair}
                        getResTypeId={getResTypeId}
                        getResType={getResType}
                        handleSetLoadingOnDelete={setLoadingOnDelete}
                        refreshData={refreshData}
                        refreshKey={reservation.update}
                    />
                </div>
            </div>

            {(reservation.loading || settings.loading) && reservation.tab !== 'info' || loadingOnDelete
                ?
                <img src={loader} alt="loading" />
                :
                (() => {
                    // Get shared parameters to pass to child components
                    const sharedParams = {
                        isShared: searchParams.get('is_shared') === 'true',
                        sharedByTenantId: searchParams.get('shared_by_tenant_id'),
                        allowedActions: searchParams.get('allowed_actions')
                    }

                    switch (reservation.tab) {
                        case 'parts':
                            return (
                                <Parts
                                    data={reservation.data}
                                    refreshData={refreshData}
                                    calculatePrice={calculatePrice}
                                    sharedParams={sharedParams}
                                />
                            )
                        case 'todo':
                            return (
                                <Todo
                                    data={reservation.data}
                                    refreshData={refreshData}
                                    sharedParams={sharedParams}
                                />
                            )
                        case 'comments':
                            return (
                                <Comments
                                    data={reservation.data}
                                    refreshData={refreshData}
                                    sharedParams={sharedParams}
                                />
                            )
                        case 'invoices':
                            return (
                                <Invoices
                                    data={reservation.data}
                                    refreshData={refreshData}
                                    sharedParams={sharedParams}
                                />
                            )
                        case 'history':
                            return (
                                <History
                                    data={reservation.data}
                                    refreshData={refreshData}
                                    sharedParams={sharedParams}
                                />
                            )
                        default:
                            return ''
                    }
                })()
            }
        </div>
    )
}

export default CreateEdit